var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8261 4.7335V17.9335H19.5111L19.5132 21.2335L13.9918 17.9335H9.57459V4.7335H22.8261ZM13.9918 0.333496V3.6335H8.47029L8.47028 14.1935L4.05312 16.8335L4.05521 13.5335H0.740234V0.333496H13.9918ZM16.8491 8.0335H15.5585L13.1083 14.6335H14.2726L14.9506 12.7425H17.4382L18.1209 14.6335H19.3553L16.8491 8.0335ZM16.1944 9.13738C16.2954 9.47429 16.4022 9.80644 16.5151 10.1338L16.5638 10.2739L17.1203 11.8389H15.2639L15.8204 10.2739C15.9762 9.84225 16.1009 9.46342 16.1944 9.13738ZM6.7982 2.11442H5.69391L5.69389 2.66439L2.93317 2.66442V3.76442L7.05519 3.76447C6.98897 4.70128 6.75037 5.54509 6.33974 6.30103C5.89388 5.6902 5.58674 5.00744 5.41643 4.24852L5.40552 4.19892L4.32585 4.42992L4.40686 4.76572C4.65272 5.68499 5.07691 6.51335 5.67739 7.24607C5.02611 7.94612 4.09281 8.43715 2.86034 8.71699L2.81339 8.72752L3.05295 9.80132L3.38258 9.7223C4.66895 9.38942 5.6956 8.82739 6.44929 8.03445C6.97753 8.48828 7.63212 8.91728 8.4129 9.32365L8.47026 9.35335L8.47025 8.10074C7.93599 7.79419 7.48548 7.479 7.11862 7.1564C7.72753 6.17071 8.07385 5.05633 8.15819 3.82072L8.16185 3.76447L8.47024 3.76442V2.66439H6.79817L6.7982 2.11442Z",
    fill: "#A9A7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.f120e49b4fbd88eca3324916258954f6.svg";
export { ForwardRef as ReactComponent };